import React from 'react';

import FormItem from './form-item';
import MandatoryFormItem from './form-mandatory-item';
import AffiliateSettings from './form-affiliate-settings';
import Icon from '../../ui/icon';
import BasicDropdown from '../../base/dropdowns/basic-dropdown';

const PublisherAuctionSetup = (
  auctionType,
  auctionTypes,
  setAuctionType,
  validDomains,
  setValidDomains,
  reserveCpc,
  setReserveCpc,
  fieldErrors,
  cogs,
  setCogs,
  amazonId,
  setAmazonId,
  termsAccepted,
  setTermsAccepted,
  enableTheTake,
  setEnableTheTake,
  enableLinkmate,
  setEnableLinkmate,
  enableAmp,
  setEnableAmp,
  recordExternalClicks,
  setRecordExternalClicks,
  defaultAffiliate,
  setDefaultAffiliate,
  affiliateTypes,
  linkmateAffiliate,
  setLinkmateAffiliate,
  notes,
  setNotes,
  skimLinkId,
  setSkimLinkId,
  impactRadiusUrl,
  setImpactRadiusUrl,
  linkShareMemberId,
  setLinkShareMemberId,
  pmgUrl,
  setPmgUrl,
  vigilinkKey,
  setVigilinkKey,
) => {
  const validDomainInputs = validDomains.map((validDomain, idx) => {
    const xBtn = idx ? (
      <div
        className="remove-domain"
        onClick={() => setValidDomains(validDomains.filter((param, index) => index !== idx))}
      >
        <Icon iconName="x" size={8} />
      </div>
    ) : null;
    return (
      <div key={idx} className="domain-area">
        <input
          type="text"
          value={validDomain}
          onChange={e => {
            const newDomains = [...validDomains];
            newDomains[idx] = e.target.value;
            setValidDomains(newDomains);
          }}
          key={idx}
        />
        {xBtn}
      </div>
    );
  });

  const checkboxItems = [
    { state: enableTheTake, setter: setEnableTheTake, label: 'Enable The Take' },
    { state: enableLinkmate, setter: setEnableLinkmate, label: 'Enable Linkmate' },
    { state: enableAmp, setter: setEnableAmp, label: 'Enable AMP' },
    {
      state: recordExternalClicks,
      setter: setRecordExternalClicks,
      label: 'Record External Clicks',
    },
  ];

  const checkBoxMap = checkboxItems.map(({ state, setter, label }, idx) => (
    <div key={idx} className="form-item">
      <label className="checkbox-label" onClick={() => setter(!state)}>
        <span
          className={`${label.replace(/ /g, '-').toLowerCase()} checkbox ${
            state ? 'selected' : ''
          }`}
        ></span>
        {label}
      </label>
    </div>
  ));

  const skimLinkIdField =
    defaultAffiliate.value === 'Skimlinks' ? (
      <MandatoryFormItem
        label="Skim Link ID"
        value={skimLinkId}
        setter={setSkimLinkId}
        type="skim_link"
        fieldErrors={fieldErrors}
      />
    ) : null;

  return (
    <div className="form">
      <FormItem label="Reserve CPC" value={reserveCpc} setter={setReserveCpc} />
      <div className={`form-item ${fieldErrors.includes('cogs') ? 'errored' : ''}`}>
        <label>
          COGS <span className="star">*</span>
        </label>
        <input
          type="text"
          className="cogs-text"
          value={cogs}
          onChange={e => setCogs(e.target.value)}
        />
      </div>
      <div className="form-item">
        <label>
          Auction Type <span className="star">*</span>
        </label>
        <div className="auction-type">
          <BasicDropdown
            items={auctionTypes}
            selectItem={idx => setAuctionType(auctionTypes[idx])}
            dropdownLabel={auctionType.label}
          />
        </div>
      </div>
      <FormItem label="Amazon Tracking ID" value={amazonId} setter={setAmazonId} />
      <div className="form-item terms-accepted">
        <label className="checkbox-label" onClick={() => setTermsAccepted(!termsAccepted)}>
          <span className={`checkbox ${termsAccepted ? 'selected' : ''}`}></span>
          Terms Accepted
        </label>
      </div>
      <div className="subtitle">JSTag Settings</div>
      {checkBoxMap}
      <div className="form-item valid-domains">
        <label>Valid Domains</label>
        <div className="valid-domains">
          {validDomainInputs}
          <button onClick={() => setValidDomains(validDomains.concat(['']))}>+ Add Domain</button>
        </div>
      </div>
      <AffiliateSettings
        defaultAffiliate={defaultAffiliate}
        linkmateAffiliate={linkmateAffiliate}
        impactRadiusUrl={impactRadiusUrl}
        setImpactRadiusUrl={setImpactRadiusUrl}
        linkShareMemberId={linkShareMemberId}
        setLinkShareMemberId={setLinkShareMemberId}
        skimLinkId={skimLinkId}
        setSkimLinkId={setSkimLinkId}
        pmgUrl={pmgUrl}
        setPmgUrl={setPmgUrl}
        vigilinkKey={vigilinkKey}
        setVigilinkKey={setVigilinkKey}
        fieldErrors={fieldErrors}
        notes={notes}
        setNotes={setNotes}
        affiliateTypes={affiliateTypes}
        setDefaultAffiliate={setDefaultAffiliate}
        setLinkmateAffiliate={setLinkmateAffiliate}
      />
    </div>
  );
};

export default PublisherAuctionSetup;
